import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

/**
 * Режим раскладки оверлея в кадре консоли.
 *
 * РЕДАКТОР НЕ ПИШЕТСЯ ЗАНОВО. Он уже есть - `apps/dashboard/src/layout`,
 * единица 5 Фазы 4: охранные зоны TikTok, привязка к краям и центру,
 * отмена, возврат одного элемента, перенос раскладки между играми,
 * равноправная клавиатура. Вторая реализация этого в консоли означала бы две
 * правды о том, где стоит элемент, и расхождение вылезло бы у зрителя.
 *
 * РЕЖИМ ОДИН НА КОНСОЛЬ, ПОЭТОМУ КОНТЕКСТ, А НЕ ХУК С СОСТОЯНИЕМ. Включают
 * его из двух мест: кнопкой у кадра и добавлением виджета из шапки. Пока это
 * был местный хук, каждый вызов заводил СВОЙ режим: панель виджетов
 * сообщала «кадр в режиме раскладки», а кадр об этом не знал.
 */
export interface LayoutMode {
  editing: boolean;
  toggle: () => void;
  /** Включить, не выключая: добавление виджета всегда ведёт в правку. */
  start: () => void;
}

const LayoutModeContext = createContext<LayoutMode>({
  editing: false,
  toggle: () => undefined,
  start: () => undefined,
});

export function LayoutModeProvider({ children }: { children: ReactNode }) {
  const [editing, setEditing] = useState(false);

  const toggle = useCallback(() => {
    setEditing((value) => !value);
  }, []);

  const start = useCallback(() => {
    setEditing(true);
  }, []);

  const value = useMemo<LayoutMode>(() => ({ editing, toggle, start }), [editing, toggle, start]);

  return <LayoutModeContext.Provider value={value}>{children}</LayoutModeContext.Provider>;
}

export function useLayoutMode(): LayoutMode {
  return useContext(LayoutModeContext);
}
